import './tooltips.css'
import {setEleCss} from '../../assets/js/common'
/**
 * @Description:  自定义指令 tooltips
 * @param:  content 内容, color 字体颜色, bgColor 背景颜色, pos 位置
 * @Author: ZhangBin
 * @Date 2019-04-23 16:06
 */
export default {
  bind(el, binding) {
    /*
    * 创建提示框元素并设置提示框默认样式
    * */
    let tips = document.createElement("span");
    tips.className = 'v_tooltips';
    tips.setAttribute('id', 'vTooltips');
    let cssObj = {
      position: "absolute",
      padding: "10px",
      borderRadius: "4px",
      lineHeight: 1,
      textAlign: 'center',
      zIndex: 9999,
      display: "none",
      opacity: 0,
      fontSize: '12px',
      fontWeight: 'bold',
      transition: 'all linear 0.2s',
    };
    if(binding.value.color) {
      let color = binding.value.color;
      cssObj = {...cssObj, color: color};
    } else {
      cssObj = {...cssObj, color: "#FFFFFF"};
    }
    if(binding.value.bgColor) {
      let bgColor = binding.value.bgColor;
      cssObj = {...cssObj, backgroundColor: bgColor};
    } else {
      cssObj = {...cssObj, backgroundColor: "#000000"};
    }
    if(binding.value.delay) {
      let delay = binding.value.delay;
      cssObj = {...cssObj, transitionDelay: delay};
    } else {
      cssObj = {...cssObj, transitionDelay: '0.5s'};
    }
    /*
    * 设置当前元素的样式并设置事件监听, 提示框以父元素为定位基准
    * */
    el.style.position = "relative";
    el.addEventListener("mouseover", function () {

      // 获取当前节点的位置
      let position = {
        width: el.getBoundingClientRect().width/2,    // 左右居中显示
        height: el.getBoundingClientRect().height/2,  // 上下居中显示
        top: el.getBoundingClientRect().top,
        left: el.getBoundingClientRect().left,
        right: el.getBoundingClientRect().right,
        bottom: el.getBoundingClientRect().bottom,
      };
      // 设置样式 默认为top
      let defaultPos = binding.value.pos || 'top';
      let pos = setPosition(tips, defaultPos, cssObj.backgroundColor, position);
      for (const item in pos) {
        cssObj[item] = pos[item];
      }
      tips.textContent = binding.value.content;
      setEleCss(tips, cssObj);
      document.body.appendChild(tips);
      // 显示
      tips.style.display = "block";
      setTimeout(() => {
        tips.style.opacity = '1';
      }, 100)
    });
    el.addEventListener("mouseout", function () {
      // 隐藏
      tips.style.opacity = "0";
      tips.style.display = "none";
      if(tips) document.body.removeChild(tips);
    });
  },
  update(el, binding) {

  },
  unbind(el) {
    // 移除tips
    let tips = document.getElementById('vTooltips');
    if(tips) document.body.removeChild(tips);
    el.removeEventListener('mouseover', () => {});
    el.removeEventListener('mouseout', () => {});

  }
}

// 根据传参设置提示框位置
function setPosition(tips, pos, color, position) {
  let sst = getStyleById();
  tips.className = 'v_tooltips';
  switch (pos) {
    case "left":
      tips.className += " left";
      sst.insertRule(
        `.v_tooltips.left:before{
            border-left: 5px solid ${color};
        }`
      );
      return {left: position.left +'px', top: position.top + position.height +'px', transform: "translateX(-110%) translateY(-50%)"};
      break;
    case "right":
      tips.className += " right";
      sst.insertRule(
        `.v_tooltips.right:before{
            border-right: 5px solid ${color};
        }`
      );
      return {left: position.left + position.width * 2 +'px', top: position.top + position.height +'px', transform: "translateX(10%) translateY(-50%)"};
      break;
    case "bottom":
      tips.className += " bottom";
      sst.insertRule(
        `.v_tooltips.bottom:before{
            border-bottom: 5px solid ${color};
        }`
      );
      return {top: position.top + position.height*2 +'px', left: position.left + position.width +'px', transform: "translateX(-50%) translateY(50%)"};
      break;
    case "top":
      tips.className += " top";
      sst.insertRule(
        `.v_tooltips.top:before{
            border-top: 5px solid ${color};
        }`
      );
      return {top: position.top + 'px', left: position.left + position.width + 'px', transform: "translateX(-50%) translateY(-130%)"};
      break;
    //top
    default:
      tips.className += " top";
      sst.insertRule(
        `.v_tooltips.top:before {
            border-bottom: 5px solid ${color};
        }`
      );
      return {top: position.top + 'px', left: position.left + position.width + 'px', transform: "translateX(-50%) translateY(-130%)"};
      break;
  }
}
// 获取指定id的style标签
function getStyleById() {
  let styleSheets = document.styleSheets;
  for (let i = 0; i < styleSheets.length; i++) {
    if (styleSheets[i].ownerNode && styleSheets[i].ownerNode.id === 'emptyRules') {
      return styleSheets[i];
      break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/tooltips/tooltips.js